var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / groups-list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 2.91699C1.66675 2.22664 2.22639 1.66699 2.91675 1.66699H5.83341V3.33366H3.33341V7.50033H5.83341V9.16699H2.91675C2.22639 9.16699 1.66675 8.60735 1.66675 7.91699V2.91699Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 4.58366H7.50008V2.91699H17.5001V4.58366Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 7.91699H7.50008V6.25033H17.5001V7.91699Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 12.0837C1.66675 11.3933 2.22639 10.8337 2.91675 10.8337H5.83341V12.5003H3.33341V16.667H5.83341V18.3337H2.91675C2.22639 18.3337 1.66675 17.774 1.66675 17.0837V12.0837Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 13.7503H7.50008V12.0837H17.5001V13.7503Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 17.0837H7.50008V15.417H17.5001V17.0837Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsList);
export default __webpack_public_path__ + "static/media/groups-list.63088d183e1af4c04b9f2d7622af4f9a.svg";
export { ForwardRef as ReactComponent };